export default {
  unlocked_plural: '{{count}} offerte sono state sbloccate',
  unlocked: "L'offerta {{offer}} è stata sbloccata",
  removed_one: "L'offerta {{offer}} è stata rimossa",
  removed_other: '{{count}} sono state rimosse',
};
